import React,{PureComponent} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Auth from 'containers/Auth';
import Notifications from 'containers/Notifications';
import Index from 'scenes/index.js';
import Login from 'components/Login';
import ResetPassword from 'scenes/ResetPassword';
import Apps from 'scenes/Apps';
import Authorise from 'scenes/Authorise';
import OAuth from 'scenes/OAuth';
import Privacy from 'scenes/Privacy';

export default class App extends PureComponent{
    render(){
        return (
            <main>
                <Router>
                    <Switch>
                        <Index>
                            <Route exact path="/" component={Login}/>
                            <Route exact path="/reset-password" component={ResetPassword}/>
                            <Route path="/apps" component={Apps}/>
                            <Route path="/authorise" component={Auth(Authorise)}/>
                            <Route path="/app/:name" component={Auth(OAuth)}/>
                            <Route path="/privacy" component={Privacy}/>
                        </Index>
                    </Switch>
                </Router>
                <Notifications/>
            </main>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes.js